<template>
  <transition-group :appear="appear" tag="div" name="slide-in-transition"  :class="[{reverse, fade, 'blink-out':blinkOut}, direction]" :style="{ '--total': total, '--time': duration }">
   <slot></slot>
  </transition-group>
</template>
<script>
export default {
  name: 'SlideInTransitionGroup',
  props: {
    total: Number,
    appear: Boolean,
    direction: {type: String, required: false, default: 'right'},
    reverse: {type: Boolean, required: false, default: false},
    fade: {type: Boolean, required: false, default: true},
    duration: {type: Number, required: false, default: 400},
    blinkOut: {type: Boolean, required: false, default: false}
  }
};
</script>

<style lang="scss">
@import '~@/scss/components/transitions/slide_in_transition_group.scss';
</style>
